import { render, staticRenderFns } from "./ProductsTableBlock.vue?vue&type=template&id=1806cc08&scoped=true"
import script from "./ProductsTableBlock.vue?vue&type=script&lang=ts"
export * from "./ProductsTableBlock.vue?vue&type=script&lang=ts"
import style0 from "./ProductsTableBlock.vue?vue&type=style&index=0&id=1806cc08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1806cc08",
  null
  
)

export default component.exports